module.exports = __webpack_public_path__ + "img/onboarding.2ec15f13.svg";